import { HttpResponseError } from '@vista-digital/http-client';
import { OrderCompletionStatus, OrderPaymentStatus } from '@vista-digital/ocapi-types/v1';
export const orderCompletionPollingPredicate = async (response)=>{
    if (!response.ok) return handleBadResponse(response);
    const orderCompletion = await response.clone().json();
    return orderCompletion.status !== OrderCompletionStatus.Pending;
};
export const orderPaymentStatusPollingPredicate = async (response)=>{
    if (!response.ok) return handleBadResponse(response);
    const orderPayment = await response.clone().json();
    return orderPayment.status !== OrderPaymentStatus.Pending;
};
export const orderPaymentStatusPollingConfiguration = {
    predicate: orderPaymentStatusPollingPredicate,
    exponentialWaitTime: true
};
const handleBadResponse = (response)=>{
    const error = new HttpResponseError(response);
    if (!error.isTransient) throw error; // No need to poll, cannot be retried.
    return false; // Return false to allow polling to continue.
};

//# sourceMappingURL=order-polling-predicates.js.map